export default __webpack_public_path__ + "static/media/cris&sara_authxrs.33f88a1b.jpg";